<template>
    <div class="loginbg">
        <el-form
                :rules="rules"
                ref="loginForm"
                v-loading="loading"
                element-loading-text="正在登录..."
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
                :model="loginForm"
                class="loginContainer">
            <h3 class="loginTitle">系统登录</h3>
            <el-form-item prop="username">
                <el-input size="normal" type="text" v-model="loginForm.adminUserName" auto-complete="off"
                          placeholder="请输入用户名"></el-input>
            </el-form-item>
            <el-form-item prop="password">
                <el-input size="normal" type="password" v-model="loginForm.adminPassword" auto-complete="off"
                          placeholder="请输入密码"></el-input>
            </el-form-item>
            <el-form-item prop="code">
                <el-input size="normal" type="text" v-model="loginForm.code" auto-complete="off"
                          placeholder="点击图片更换验证码" @keydown.enter.native="submitLogin" style="width: 250px"></el-input>
                <img :src="vcUrl" @click="updateVerifyCode" alt="" style="cursor: pointer">
            </el-form-item>
            <el-checkbox size="normal" class="loginRemember" v-model="checked"></el-checkbox>
            <el-button size="normal" type="primary" style="width: 100%;" @click="submitLogin">登录</el-button>
        </el-form>
    </div>
</template>

<script>
import {Message} from 'element-ui';
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
    export default {
        name: "Login",
        data() {
            return {
                loading: false,
                stompClient:{},
                socket:{},
                vcUrl: '/verifyCode?time='+new Date(),
                loginForm: {
                    adminUserName: '',
                    adminPassword: ''
                   // code:''
                },
                checked: true,
                rules: {
                    adminUserName: [{required: true, message: '请输入用户名', trigger: 'blur'}],
                    adminPassword: [{required: true, message: '请输入密码', trigger: 'blur'}]
                    //code: [{required: true, message: '请输入验证码', trigger: 'blur'}]
                }
            }
        },
        created() {
            var that = this;
            //当前页面监视键盘输入
            document.onkeydown = function(e) {//事件对象兼容
                let e1 = e || event || window.event || arguments.callee.caller.arguments[0]
                //键盘按键判断:左箭头-37;上箭头-38；右箭头-39;下箭头-40
                //左
                if (e1 && e1.keyCode == 37) {
                    that.decrease()
                } else if (e1 && e1.keyCode == 38) {
                    that.nowStudent--
                } else if (e1 && e1.keyCode == 39) {
                    that.increase()
                } else if (e1 && e1.keyCode == 40) {
                    that.nowStudent++
                }else if (e1 && e1.keyCode == 13) {
                    that.submitLogin();
                }
            }
        },
        methods: {
            updateVerifyCode() {
                this.vcUrl = '/verifyCode?time='+new Date();
            },
            submitLogin() {
                this.$refs.loginForm.validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        this.postRequest('/admin/login', this.loginForm).then(resp => {
                            this.loading = false;
                            if (resp) {    
                                this.$store.commit('INIT_CURRENTHR', resp.data);
                             
                                window.sessionStorage.setItem("user", JSON.stringify(resp.data));  
                                let path = this.$route.query.redirect;
                                this.$router.replace((path == '/' || path == undefined) ? '/home' : path);
                            }else{
                                this.vcUrl = '/verifyCode?time='+new Date();
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
           
        }
    }
</script>

<style>
    .loginbg{
        background-image: image('./assets/1231232.jpg');
    }
    .loginContainer {
        border-radius: 15px;
        background-clip: padding-box;
        margin: 180px auto;
        width: 350px;
        padding: 15px 35px 15px 35px;
        background: #fff;
        border: 1px solid #eaeaea;
        box-shadow: 0 0 25px #cac6c6;
    }

    .loginTitle {
        margin: 15px auto 20px auto;
        text-align: center;
        color: #505458;
    }

    .loginRemember {
        text-align: left;
        margin: 0px 0px 15px 0px;
    }
    .el-form-item__content{
        display: flex;
        align-items: center;
    }
</style>
